import {SET_USER_FEEDBACK, SET_USER_FEEDBACK_SUCCESS, SET_USER_FEEDBACK_FAILURE } from '../constants';

const initialState = {
    feebackMessage: {},
    fetchingFeedbackMessage: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_FEEDBACK:
            return {
                ...state,
                fetchingFeedbackMessage: true
            };
        case SET_USER_FEEDBACK_SUCCESS:
            return {
                ...state,
                message: action.message,
                fetchingFeedbackMessage: false
            };
        case SET_USER_FEEDBACK_FAILURE:
            return {
                ...state,
                error: action.error,
                fetchingFeedbackMessage: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/setUserFeedback.js